"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHandleBasketOutcomesLength = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const types_1 = require("../ConfigProvider/types");
const selectors_1 = require("../ConfigProvider/selectors");
const selectors_2 = require("./selectors");
const slice_1 = require("./slice");
// we check some errors for "web-mobile" EXPRESS_LENGTH and SYSTEM_LENGTH on change in the number of outcomes
const useHandleBasketOutcomesLength = () => {
    const outcomesLength = (0, react_redux_1.useSelector)(selectors_2.selectBasketOutcomesLength);
    const config = (0, react_redux_1.useSelector)(selectors_1.selectConfig);
    const dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(() => {
        if (config.CLIENT_TYPE === types_1.EClientTypes.WEB_MOBILE) {
            dispatch(slice_1.basketProviderActions.triggerBasketOutcomesLength());
        }
    }, [config, dispatch, outcomesLength]);
};
exports.useHandleBasketOutcomesLength = useHandleBasketOutcomesLength;
//# sourceMappingURL=useHandleBasketOutcomesLength.js.map